"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BaseComponents {
}
exports.default = BaseComponents;
//# sourceMappingURL=BaseComponents.js.map